import { Content } from '@radix-ui/react-dropdown-menu';
import styled, { css } from 'styled-components';
import { DropdownMenuSize, DropdownMenuType, DropdownMenuVariant } from '.';
import { construirSombra } from '@/styles/theme';

export type DropdownMenuConteudoProps = {
  $size: DropdownMenuSize;
  $variant: DropdownMenuVariant;
  $highContrast: boolean;
  $type: DropdownMenuType;
};

export const DropdownMenuConteudo = styled(Content)<DropdownMenuConteudoProps>`
  z-index: 1;
  max-height: 150px;
  overflow-y: auto;

  background-color: ${({ theme }) => theme.panel.solid};
  ${({ theme, $size }) => {
    return css`
      border-radius: ${theme.radius[$size + 1]}px;
      padding: ${theme.spacing[$size]}px;
    `;
  }}

  box-shadow: ${construirSombra('shadow_5')};

  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral_alpha['3']};

  padding: ${({ theme }) => theme.spacing['2']}px;
`;
